import { useState, useCallback } from 'react'

/**
 * @description A hook to handle modal state
 * @param {boolean} initialState
 * @returns {isOpen: boolean, handleOpenModal: function, handleCloseModal: function, handleToggleModal: function, lastEvent: object}
 */
const useModal = (initialState) => {
  const [isOpen, setIsOpen] = useState(initialState)
  const [lastEvent, setLastEvent] = useState(null)

  const saveEvent = useCallback((event) => {
    if (event) {
      event?.preventDefault()
      event?.persist()
      setLastEvent({ ...event })
    }
  }, [])

  const handleOpenModal = useCallback((event) => {
    saveEvent(event)
    setIsOpen(true)
  }, [])

  const handleCloseModal = useCallback((event) => {
    saveEvent(event)
    setIsOpen(false)
  }, [])

  const handleToggleModal = useCallback((event) => {
    saveEvent(event)
    setIsOpen((isOpen) => !isOpen)
  }, [])

  return { isOpen, handleOpenModal, handleCloseModal, handleToggleModal, lastEvent }
}

export default useModal
